const routeStack: string[] = [];
let isBackNavigation = false;

export const pushRoute = (path: string): void => {
  const last = routeStack.at(-1);

  // 연속 중복 방지
  if (last !== path) {
    routeStack.push(path);
  }
};

export const markBackNavigation = (): void => {
  isBackNavigation = true;
};

export const consumeBackNavigation = (): boolean => {
  const value = isBackNavigation;
  isBackNavigation = false;
  return value;
};

export const popRoute = (): string | undefined => {
  return routeStack.pop();
};

export const canGoBack = (): boolean => {
  return routeStack.length > 0;
};

export const getRouteStack = (): readonly string[] => {
  return routeStack;
};
